module.exports = "//docs.gtimg.com/slide/img/_/node_modules/@tencent/docs-design-resources/icon/mobile/svg/ai_newlogo_24-afe648.svg";